import { useState } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft, Mail, CheckCircle2 } from "lucide-react";
import { api, formatApiError } from "@/lib/api";
import { AuthShell, Logo } from "@/components/AuthShell";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Card, CardContent } from "@/components/ui/card";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthShell>
      <div className="flex justify-center mb-8"><Logo size="lg" /></div>
      <Card className="rounded-2xl border-slate-200 shadow-lg shadow-slate-200/50">
        <CardContent className="p-6 sm:p-8">
          <Link to="/login" data-testid="back-to-login"
            className="inline-flex items-center text-sm text-slate-500 hover:text-primary mb-4">
            <ArrowLeft className="h-4 w-4 mr-1" /> Torna all'accesso
          </Link>

          {!sent ? (
            <>
              <h1 className="font-heading text-2xl font-bold tracking-tight text-slate-900">Password dimenticata</h1>
              <p className="text-sm text-slate-500 mt-1 mb-6">
                Inserisci la tua email: riceverai un link per reimpostare la password.
              </p>
              {error && (
                <div data-testid="forgot-error"
                  className="mb-4 rounded-lg bg-destructive/10 text-destructive text-sm px-3 py-2 border border-destructive/20">
                  {error}
                </div>
              )}
              <form onSubmit={submit} className="space-y-4">
                <div className="space-y-1.5">
                  <Label htmlFor="email">Email</Label>
                  <Input id="email" type="email" required value={email} data-testid="forgot-email-input"
                    onChange={(e) => setEmail(e.target.value)} placeholder="nome@orbit.it" />
                </div>
                <Button type="submit" disabled={loading} data-testid="forgot-submit-btn"
                  className="w-full rounded-lg h-11 font-semibold transition-all duration-200 hover:brightness-110 active:scale-[0.98]">
                  <Mail className="h-4 w-4 mr-2" />
                  {loading ? "Invio..." : "Invia link di recupero"}
                </Button>
              </form>
            </>
          ) : (
            <div data-testid="forgot-success">
              <div className="flex justify-center mb-4">
                <div className="h-14 w-14 rounded-full bg-success/10 flex items-center justify-center">
                  <CheckCircle2 className="h-7 w-7 text-success" />
                </div>
              </div>
              <h1 className="font-heading text-xl font-bold text-center text-slate-900">Controlla la tua email</h1>
              <p className="text-sm text-slate-500 mt-2 text-center">
                Se l'email esiste, riceverai le istruzioni per reimpostare la password.
              </p>
            </div>
          )}
        </CardContent>
      </Card>
    </AuthShell>
  );
}
